import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Error from '../../Components/UiErrorComponents/Error';
import Loading from '../../Components/UiLoadingComponents/Loading';
import { useGetAdminsQuery, useUpdateAdminPasswordMutation } from '../../features/auth/authApi';

const ForgetPasswordModalContent = ({ setIsOpen }) => {
    const { register, reset, handleSubmit, watch, formState: { errors } } = useForm();
    const { data: [adminInfo] = [], isLoading: isAdminInfoLoading, isError: isAdminInfoError, } = useGetAdminsQuery()
    const [updatePassword, { isLoading, isSuccess, isError }] = useUpdateAdminPasswordMutation()

    // relative password of input
    const password = watch('password')
    const onSubmit = data => {
        // submitToRegister(data)
        if (data.email !== adminInfo?.email) {
            toast.error('This is not an admin')
            return
        }
        updatePassword({
            ...adminInfo,
            password: data.password
        })
    };

    useEffect(() => {
        if (isSuccess) {
            toast.success('successfully password updated!')
            setIsOpen(false)
        }
        if (isError) {
            toast.error('something went wrong')

        }
    }, [isSuccess, isError,])

    let content = null;
    if (isAdminInfoLoading) {
        content = <div className='flex justify-center'>
            <Loading></Loading>
        </div>
    } else if (isAdminInfoError) {
        content = <div>
            <Error error={"Error while getting admin info"}></Error>
        </div>
    } else if (!adminInfo.email) {
        content = <div>
            <Error error={"Error while getting admin info"}></Error>
        </div>
    } else {
        content = <div>
            <h2 className='text-center text-xl font-semibold'>Enter new Password</h2>
            <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-6"  >
                <div className="rounded-md shadow-sm -space-y-px">
                    <div>
                        <label htmlFor="email-address" className="sr-only">Email address</label>
                        <input id="email-address"  {...register("email", { required: true })} name="email" type="email" autoComplete="email" required
                            className="login-input block mt-5 " placeholder="Email address" />
                    </div>
                    <div>
                        <label htmlFor="password" className="sr-only ">Password</label>
                        <input  {...register("password", { required: true, pattern: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[@#$%^&+=!])(?!.*\s).{8,}$/ })} id="password" name="password" type="password" autoComplete="current-password" required
                            className="login-input block mt-5" placeholder="Password" />
                        {errors.password?.type === "pattern" && (
                            <p className='text-error py-2'>Password must be have one number one text one special symbol and at least 8 characters long  </p>
                        )}
                    </div>
                    <div className=''>
                        <label htmlFor="confirmPassword" className="sr-only">Confirm Password</label>
                        <input id="confirmPassword" name="confirmPassword"
                            {...register('confirmPassword', {
                                required: true,
                                validate: (value) => value === password || "The passwords do not match",
                            })}
                            type="password"
                            autoComplete="confirm-password" required className="login-input rounded-b-md mt-5"
                            placeholder="Confirm Password" />
                        {errors.confirmPassword?.message && <p className=' py-2 text-error'>
                            <FontAwesomeIcon icon={faCircleExclamation}></FontAwesomeIcon>
                            <span className='ml-2'>{errors.confirmPassword.message}!</span></p>}
                    </div>
                </div>
                <div>
                    <button
                        disabled={isAdminInfoLoading}
                        type="submit"
                        className="group relative flex justify-center py-2 px-4  text-sm font-medium rounded-md text-white border border-cyan-500 hover:opacity-70 ">
                        Save Password
                    </button>
                </div>
            </form>
        </div>
    }

    return (
        <>
            {content}

        </>
    );
};

export default ForgetPasswordModalContent;